import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/2025.webp';
import { resetPassword } from '../../Api';

function NewPassword() {
  const location = useLocation();
  const navigate = useNavigate();
  const canAccess = sessionStorage.getItem('canAccessReset') === 'true';
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!canAccess) {
      navigate('/forgot-password');
    }
    sessionStorage.removeItem('canAccessValidate');
  }, [canAccess, navigate]);

  const email = location.state?.email;

  const [formData, setFormData] = useState({
    email: email,
    password: '',
    confirmPassword: '',
  });

  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccessMessage(null);

    const { password, confirmPassword } = formData;

    // Validation checks
    if (password !== confirmPassword) {
      setError('Password tidak sama.');
      return;
    }
    if (password.length < 6) {
      setError('Password setidaknya 6 karakter.');
      return;
    }

    try {
      await resetPassword({ email, password });
      setSuccessMessage('Password berhasil direset. Mengalihkan kehalaman login...');
      setTimeout(() => navigate('/'), 2000); 
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message || 'Gagal mereset password.');
      } else {
        setError('Gagal mereset password.');
      }
    } finally {
        setLoading(false);
      }
  };

  return (
    <div className="login-page">
      <img src={Logo} alt="Filadelfia Blessing Family" className="logo" />
      {successMessage && <p className="success">{successMessage}</p>}
      {error && <p className="error">{error}</p>}
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="input-group">
          <input
            type="password"
            name="password"
            placeholder="New Password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>
        <div className="input-group">
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm New Password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" disabled={loading}>{loading ? 'Proses data...' : 'Reset Password'}</button>
      </form>

      
    </div>
  );
}

export default NewPassword;
